import { VariableType } from 'json-to-graphql-query';

export const StateFilterVariables = { filters: 'FiltersInput' };
export const StateFilterArgs = {
  filters: new VariableType('filters')
};

export const FilterVariables = { filters: 'FiltersInput' };
export const FilterArgs = {
  filters: new VariableType('filters')
};
